const config = {
    sdk: 'NIM_Web_SDK_v6.1.0',

    // 资源路径根目录，为了方便用户部署在二级以上URL路径上
    resourceUrl: 'http://yx-web.nos.netease.com/webdoc/h5',
    // 用户logo地址
    logo: 'http://yx-web.nos.netease.com/webdoc/h5/im/logo.png',
    // 默认用户头像
    defaultUserIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-icon.png',
    // 默认普通群头像
    defaultGroupIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-group.png',
    // 默认高级群头像
    defaultAdvancedIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/default-advanced.png',
    // 系统通知图标
    noticeIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/notice-icon.png',
    // 我的手机图标
    myPhoneIcon: 'http://yx-web.nos.netease.com/webdoc/h5/im/my-phone.png',
    // 本地消息显示数量，会影响性能
    localMsglimit: 36,
    useDb: false,
    reduxStoreName: 'IMPlatformStore', // 外部引入后，IM 组件的 redux store 名字，可配置
};

const env = 'online';
// const env = 'test';

const appConfig = {
    // 用户的appkey
    // 用于在web demo中注册账号异步请求demo 服务器中使用
    test: {
        appkey: 'f31092f01d8b29004d529082c0489164',
        postUrl: 'https://apptest.netease.im',
    },
    online: {
        // appkey: '45c6af3c98409b18a84451215d0bdd6e', // 网易
        appkey: 'eb5be4a2f72122a8dcad25375fb9a930', // 生产
        // appkey: 'eb5be4a2f72122a8dcad25375fb9a930', // 生产
        // appkey: '4f9c65a3b8c6a4cd7fd1020f41da80e2', // 测试 7
        // appkey: '9a9d75670a97e16c6da7ea8b5e6e74b2', // 测试 8
        // appkey: '754d16cabc05cf281997aa86156c5bd5', // 测试 9
        // appkey: '872dc241beac97f9f995a1209e79e0db', // 测试 10
        // appkey: 'aaf5d8f2d235d4ab2c99b04c1abf51e5',
        // appkey: 'aa424f33-68c5-4e18-8e29-7d7293dc78f2',
        postUrl: 'https://app.netease.im',
    },
};

export default { ...config, ...appConfig[env] };
